import { useState, useRef } from 'react';

interface OtpModalProps {
  onConfirm: (otp: string) => void;
  onClose: () => void;
  loading: boolean;
}

export function OtpModal({ onConfirm, onClose, loading }: OtpModalProps) {
  const [digits, setDigits] = useState(['', '', '', '']);
  const inputsRef = useRef<(HTMLInputElement | null)[]>([]);

  const handleChange = (index: number, value: string) => {
    if (!/^\d?$/.test(value)) return;
    const next = [...digits];
    next[index] = value;
    setDigits(next);

    if (value && index < 3) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
    if (e.key === 'Backspace' && !digits[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const otp = digits.join('');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3 style={{ marginBottom: 8, fontSize: 18 }}>Delivery OTP</h3>
        <p style={{ color: 'var(--text-secondary)', marginBottom: 20, fontSize: 14 }}>
          Enter the 4-digit OTP from the customer to confirm delivery.
        </p>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginBottom: 20 }}>
          {digits.map((d, i) => (
            <input
              key={i}
              ref={(el) => { inputsRef.current[i] = el; }}
              className="input"
              style={{
                width: 56,
                height: 56,
                textAlign: 'center',
                fontSize: 24,
                fontWeight: 700,
                padding: 0,
              }}
              type="tel"
              inputMode="numeric"
              maxLength={1}
              value={d}
              onChange={(e) => handleChange(i, e.target.value)}
              onKeyDown={(e) => handleKeyDown(i, e)}
            />
          ))}
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-outline btn-full" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-success btn-full"
            disabled={otp.length !== 4 || loading}
            onClick={() => onConfirm(otp)}
          >
            {loading ? 'Verifying...' : 'Confirm Delivery'}
          </button>
        </div>
      </div>
    </div>
  );
}
